import Typography from "@material-ui/core/Typography";
import React from "react";
import { panelSodimacResources} from "../endpoints";
import TablaPanel from "../components/TablaPanel";
import {Grid} from "@material-ui/core";
import {Autocomplete} from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import SearchIcon from "@mui/icons-material/Search";

class PanelSodimacSemanal extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            disponibles: [],
            openSnack:false,
            message: null,
            severity:null,
            regiones_comerciales:[],
            regiones_prevencion:[],
            region_comercial: null,
            region_prevencion:  null,
            disabled: true,
            totalRows: 0,
            loading: false,
            paginationModel: { page: 0, pageSize: 25 },
            sortModel: [{ field: 'fecha', sort: 'desc' }],
            search: ""
        }
    }


    componentDidMount() {
        this.obtenerRegionesComerciales()
    }

    handleClose = ()=>{
        this.setState({ generar_excel:false})
    }

    handlePaginationModelChange = (newModel) => {
        this.setState({ paginationModel: newModel }, this.obtenerInvDisponibles);
    };

    handleSortModelChange = (newSortModel) => {
        this.setState({ sortModel: newSortModel }, this.obtenerInvDisponibles);
    };

    obtenerInvDisponibles = () => {
        if (!this.state.region_prevencion?.region_prevencion) return;

        this.setState({ loading: true, openSnack: false, severity: null, message: null });
        const region_prevencion = this.state.region_prevencion.region_prevencion;
        const { page, pageSize } = this.state.paginationModel;
        const sort_by = this.state.sortModel[0]?.field || null;
        const order = this.state.sortModel[0]?.sort || "desc";
        const search = this.state.search;

        panelSodimacResources.getPanelSemanal(region_prevencion, page, pageSize, search, sort_by, order)
            .then(async response => response ? await response.json() : null)
            .then(data => {
                if (data && data.status_code === 200) {
                    this.setState({
                        disponibles: data.inv_disponibles,
                        totalRows: data.total_count,
                        loading: false
                    });
                } else if (data && data.status_code === 401) {
                    this.setState({ openSnack: true, severity: data.severity, message: data.message, loading: false });
                } else {
                    throw new Error('Something went wrong ...');
                }
            })
            .catch(error => {
                console.error(error);
                this.setState({ loading: false });
            });
    };

    handleSearchChange = (event) => {
        const valor = event.target.value;
        this.setState({ search: valor });

        if (this.searchTimeout) clearTimeout(this.searchTimeout);

        this.searchTimeout = setTimeout(() => {
            this.setState({ paginationModel: { ...this.state.paginationModel, page: 0 } }, () => {
                this.obtenerInvDisponibles();
            });
        }, 600);
    }

    refrescar =(estado,severity) =>{
        this.setState({ generar_excel:false, openSnack: false})
        if (severity){
            this.setState({
                openSnack: true,
                message: estado,
                severity: severity
            })
        }
    }

    obtenerRegionesComerciales = () => {
        panelSodimacResources.getRegionesComerciales().then(async response => response ? await response.json() : null)
            .then(data => {
                if (data.status_code === 200) {
                    this.setState({ regiones_comerciales: data.regiones_comerciales });
                    if (data.regiones_comerciales.length > 0) {
                        this.setState({ region_comercial: data.regiones_comerciales[0] }, () => {
                            this.obtenerRegionesPrevencion();
                        });
                    }
                }
            });
    };

    obtenerRegionesPrevencion = () => {
        this.setState({ disabled: false });
        panelSodimacResources.getRegionesPrevencion(this.state.region_comercial.region_comercial)
            .then(async response => response ? await response.json() : null)
            .then(data => {
                if (data.status_code === 200) {
                    this.setState({ regiones_prevencion: data.regiones_prevencion });
                    this.setState({ region_prevencion: data.regiones_prevencion[0] }, () => {
                        this.obtenerInvDisponibles();
                    });
                }
            });
    };

    render() {
        return (
            <div>
                <Typography variant="h4" gutterBottom>Panel de control semanal</Typography>
                <Grid container spacing={2} style={{ padding: '10px' }}>
                    <Grid item xs={3}>
                        <div style={{ maxWidth: 400 }}>
                            <TextField
                                fullWidth
                                variant="outlined"
                                size="small"
                                placeholder="Buscar tienda, categoria, folio..."
                                value={this.state.search}
                                onChange={this.handleSearchChange}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position="start">
                                            <SearchIcon color="action" />
                                        </InputAdornment>
                                    ),
                                }}
                            />
                        </div>  
                    </Grid>
                    <Grid item xs={3}>
                        <Autocomplete
                            disableClearable
                            onChange={(event, newValue) => {
                                this.setState({
                                    region_comercial: newValue,
                                    regiones_prevencion: [],
                                    region_prevencion: { region_prevencion: '' },
                                    disabled: true
                                }, this.obtenerRegionesPrevencion);
                            }}
                            size="small"
                            options={this.state.regiones_comerciales}
                            value={this.state.region_comercial}
                            getOptionLabel={(option) => option.region_comercial || ""}
                            renderInput={(params) => <TextField {...params} variant="standard" label="Regiones Comerciales" />}
                        />
                    </Grid>
                    <Grid item xs={3}>
                        {!this.state.disabled &&
                            <Autocomplete
                                disableClearable
                                onChange={(event, newValue) => {
                                    this.setState({ region_prevencion: newValue }, this.obtenerInvDisponibles);
                                }}
                                size="small"
                                options={this.state.regiones_prevencion}
                                value={this.state.region_prevencion}
                                getOptionLabel={(option) => option.region_prevencion || ""}
                                renderInput={(params) => <TextField {...params} variant="standard" label="Regional de Prevención" />}
                            />
                        }
                    </Grid>
                </Grid>
                <TablaPanel
                    disponibles={this.state.disponibles}
                    totalRows={this.state.totalRows}
                    loading={this.state.loading}
                    paginationModel={this.state.paginationModel}
                    onPaginationModelChange={this.handlePaginationModelChange}
                    sortModel={this.state.sortModel}
                    onSortModelChange={this.handleSortModelChange}
                />
            </div>
        )
    }
}
export default PanelSodimacSemanal;